import React from 'react';
interface Partner {
  name: string;
  src: string;
  imgClass: string;
}
const partners: Partner[] = [{
  name: 'Invesco',
  src: 'https://cdn.magicpatterns.com/uploads/gbMX8W4UHDn3Cok5vHQEoQ/IVZ_BIG-50c3392f.png',
  imgClass: 'max-h-8 sm:max-h-9'
}, {
  name: 'Fidelity Investments',
  src: 'https://cdn.magicpatterns.com/uploads/7Eyo5wBZhga9RcRR9qN9zy/png-clipart-logo-fidelity-investments-investor-business-corporation-business-text-people.png',
  imgClass: 'max-h-9 sm:max-h-10'
}, {
  name: 'Progressive',
  src: 'https://cdn.magicpatterns.com/uploads/2FA1cJMSiBKsoGMTSx3YDM/PROGRESSIVE.png',
  imgClass: 'max-h-6 sm:max-h-7'
}, {
  name: 'Rocket Mortgage',
  src: 'https://cdn.magicpatterns.com/uploads/fQmmhDSYRDx3PVhETnpLY6/Rocket-Mortgage-Logo-768x432.png',
  imgClass: 'max-h-12 sm:max-h-14'
}];
export function Partners() {
  return <section className="w-full bg-ivory py-24 sm:py-32 lg:py-40" aria-labelledby="partners-title" data-id="element-213" data-mp="35yrl5eszzdpd">
      <div className="mx-auto max-w-page px-5 sm:px-10 lg:px-12" data-id="element-214" data-mp="16r66nqclr4ev">
        <div className="mx-auto max-w-2xl text-center" data-id="element-215" data-mp="12oj7139owf74">
          <p className="font-sans text-[10px] font-medium uppercase tracking-widest2 text-champagne sm:text-[11px]" data-id="element-216" data-mp="12q45v531ekas">
            Respaldo y experiencia
          </p>
          <h2 id="partners-title" className="mt-7 font-sans text-[1.6rem] font-light uppercase leading-[1.15] text-ink sm:text-[2.1rem]" data-id="element-217" data-mp="1boza4bmitkbg">
            Compañías con las que trabajamos
          </h2>
          <p className="mt-6 font-sans text-base font-light leading-relaxed text-steel sm:text-[17px]" data-id="element-218" data-mp="1leiszha8he6b">
            Acceso a compañías reconocidas del sector y a diferentes soluciones
            de acuerdo con las necesidades de cada persona o familia.
          </p>
        </div>

        <ul className="mx-auto mt-14 grid max-w-4xl grid-cols-2 gap-x-10 gap-y-10 sm:mt-16 sm:gap-x-14 lg:grid-cols-4 lg:gap-x-16" data-id="element-219" data-mp="51k9kqb6b386">
          {partners.map(partner => <li key={partner.name} className="flex h-24 items-center justify-center border border-ink/8 bg-white/50 px-6 sm:h-28" data-id="element-220" data-mp="204gxhvf2a2pl">
              <img src={partner.src} alt={partner.name} className={`w-auto max-w-full object-contain ${partner.imgClass}`} data-id="element-221" data-mp="254v5xekkreo5" />
            </li>)}
        </ul>
      </div>
    </section>;
}